// Single shared Stripe.js loader. Reuses the same Promise across the app so
// Stripe.js is only fetched once, regardless of how many components mount.
import { loadStripe } from "@stripe/stripe-js";

let _stripePromise = null;

export function getStripePromise() {
  if (!_stripePromise) {
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      // eslint-disable-next-line no-console
      console.error("REACT_APP_STRIPE_PUBLISHABLE_KEY is missing — SEPA mandate UI will not load.");
      return null;
    }
    _stripePromise = loadStripe(key);
  }
  return _stripePromise;
}
